const tabs = document.querySelector(".choose-deal__tabs");
const firstSpan = document.querySelector(".choose-deal__tabs .first-span");
const secondSpan = document.querySelector(".choose-deal__tabs .second-span");
const wrapper = document.querySelector(".choose-deal__wrapper");
const slider = document.querySelector(".choose-deal__swiper");
const slides = slider.querySelectorAll(".choose-deal__slide");
tabs.addEventListener("click", onTabsChange);
function onTabsChange(e) {
  const isSecond = wrapper.classList.toggle("second");
  if (isSecond) {
    firstSpan.classList.add("span-hidden");
    secondSpan.classList.remove("span-hidden");
  } else {
    secondSpan.classList.add("span-hidden");
    firstSpan.classList.remove("span-hidden");
  }
}

window.addEventListener("resize", function () {
  const width = slider.offsetWidth;
  slides.forEach((s) => (s.style.width = width + "px"));
});
